<template>
  <v-dialog persistent width="480" v-model="active">
    <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
      <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Resultados C3</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" align="center">
              <div class="text-subtitle-1 font-weight-bold">
                Vigencia de evaluaciones C3 <span class="red--text">*</span>
              </div>
              <v-date-picker
                v-model="fechaElegida"
                locale="es"
                color="secondary"
                no-title
                full-width
                :rules="required"
              ></v-date-picker>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="resultadoElegido"
                filled
                rounded
                dense
                class="mt-4"
                color="secondary"
                background-color="primary"
                :items="resultados"
                item-value="title"
                item-text="title"
                item-color="secondary"
                :rules="required"
              >
                <template v-slot:label>Resultado <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <v-btn text class="error--text mb-4 mx-8 ui-module-btn-text-danger" v-on:click="closeDialog()">
          Cancelar
        </v-btn>
        <v-btn
          color="secondary"
          class="primary--text px-8 mb-4 ui-module-btn-solid"
          :loading="loading"
          :disabled="!resultadoElegido || !fechaElegida || loading"
          v-on:click="saveResultados()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
    },

    personal: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
      fechaElegida: null,
      resultadoElegido: null,

      resultados: [
        { id: 1, title: 'Aprobado' },
        { id: 2, title: 'No aprobado' },
        { id: 3, title: 'No cubre perfil' },
        { id: 3, title: 'Sí cubre perfil' },
      ],

      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    fecha() {
      return this.asuntosInternos.fecha ? moment(this.asuntosInternos.fecha).format(this.API_DATE_FORMAT) : ''
    },
  },

  methods: {
    ...mapActions('personal', ['updatePersonal', 'fetchPersonal']),
    ...mapActions('preaspirante', ['fetchAspirantes']),
    ...mapActions('resultadosPersonalesC3', ['createResultado']),

    closeDialog() {
      this.$emit('close')
      this.loading = false
    },

    async saveResultados() {
      this.loading = true
      this.personal.observacionesC3 = this.resultadoElegido
      this.personal.examenC3Mes = moment(this.fechaElegida).format('MMMM')
      this.personal.vigenciaAnio = moment(this.fechaElegida).year()
      await this.updatePersonal(this.personal)

      await this.createResultado({
        idPersonal: this.personal.idPersonal,
        resultado: {
          resultado: this.resultadoElegido,
          fechaVigenciaEvaluacionC3: moment(this.fechaElegida).format('DD/MM/YYYY HH:mm:ss a'),
        },
      })

      await this.fetchAspirantes()

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
/* ===========================
   REGISTRO RESULTADOS C3 - ESTILOS MODERNOS
   =========================== */

/* Dialog glassmorphism */
::v-deep .v-dialog {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Card principal */
.ui-module-card {
  background: rgba(46, 38, 22, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(247, 183, 49, 0.3);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

/* Card title */
::v-deep .v-card__title {
  color: #f7b731 !important;
  padding: 24px 24px 16px 24px !important;
  border-bottom: 1px solid rgba(247, 183, 49, 0.2);
  font-size: 1.25rem !important;
  letter-spacing: 0.5px;
}

/* Card text y contenido */
::v-deep .v-card__text {
  color: #e0e0e0 !important;
  padding: 24px !important;
}

.text-subtitle-1 {
  color: #e0e0e0 !important;
}

/* Date picker */
::v-deep .v-date-picker-header {
  background: rgba(247, 183, 49, 0.1) !important;
}

::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-table th {
  color: rgba(247, 183, 49, 0.8) !important;
}

::v-deep .v-date-picker-table td {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background: #f7b731 !important;
  color: #1a1a1a !important;
}

::v-deep .v-date-picker-table .v-btn:hover:not(.v-btn--active) {
  background: rgba(247, 183, 49, 0.2) !important;
}

::v-deep .v-picker__title {
  background: rgba(247, 183, 49, 0.15) !important;
  color: #f7b731 !important;
}

::v-deep .v-picker__body {
  background: rgba(30, 30, 30, 0.4) !important;
}

/* Select */
::v-deep .v-select .v-input__slot {
  background: rgba(30, 30, 30, 0.4) !important;
  border: 1px solid rgba(247, 183, 49, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-select .v-input__slot:hover {
  border-color: rgba(247, 183, 49, 0.4) !important;
  background: rgba(30, 30, 30, 0.6) !important;
}

::v-deep .v-select.v-input--is-focused .v-input__slot {
  border-color: #f7b731 !important;
  box-shadow: 0 0 0 3px rgba(247, 183, 49, 0.15) !important;
  background: rgba(30, 30, 30, 0.7) !important;
}

::v-deep .v-select .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .v-label {
  color: rgba(255, 255, 255, 0.6) !important;
}

::v-deep .v-select.v-input--is-focused .v-label {
  color: #f7b731 !important;
}

::v-deep .v-icon {
  color: rgba(247, 183, 49, 0.6) !important;
}

::v-deep .v-select.v-input--is-focused .v-icon {
  color: #f7b731 !important;
}

/* Menu de opciones del select */
::v-deep .v-menu__content {
  background: rgba(46, 38, 22, 0.98) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(247, 183, 49, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list-item {
  color: #e0e0e0 !important;
  transition: all 0.2s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(247, 183, 49, 0.15) !important;
}

::v-deep .v-list-item--active {
  background: rgba(247, 183, 49, 0.25) !important;
  color: #f7b731 !important;
}

/* Card actions */
::v-deep .v-card__actions {
  padding: 16px 24px 24px 24px !important;
  border-top: 1px solid rgba(247, 183, 49, 0.1);
  background: rgba(247, 183, 49, 0.05) !important;
}

/* Botones */
::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0.4px;
  min-width: 148px;
  transition: all 0.3s ease !important;
}

::v-deep .ui-module-actions .primary--text {
  color: #1a1a1a !important;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #1a1a1a !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.28) !important;
}

::v-deep .ui-module-actions .ui-module-btn-text-danger {
  color: #ff6b6b !important;
}

::v-deep .ui-module-actions .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.4) !important;
}

::v-deep .ui-module-actions .v-btn:disabled {
  opacity: 0.45 !important;
}

/* Loading state */
::v-deep .v-btn--loading {
  pointer-events: none;
}

::v-deep .v-btn--loading .v-btn__content {
  opacity: 0.5;
}

/* Colores de texto */
.red--text {
  color: #ff5252 !important;
}

/* Responsive */
@media (max-width: 600px) {
  ::v-deep .v-card__title {
    font-size: 1.1rem !important;
    padding: 20px 16px 12px 16px !important;
  }

  ::v-deep .v-card__text {
    padding: 16px !important;
  }

  ::v-deep .v-card__actions {
    padding: 12px 16px 20px 16px !important;
  }

  ::v-deep .v-btn {
    min-width: 100px !important;
  }
}
</style>
